// ─── Módulos del seminario ──────────────────────────────────────────────────
// Qué partes del sistema USA un seminario. No es un permiso —eso lo dice el
// cargo, y lo hace cumplir el servidor— ni un flag de plataforma —eso dice si
// una función está liberada—: es la configuración del propio seminario. Un
// módulo apagado esconde su menú y sus páginas (personal y portal); sus datos
// quedan intactos y vuelven al encenderlo.
//
// UNA CLAVE AUSENTE CUENTA COMO ENCENDIDA. Un seminario que nunca configuró sus
// módulos ve exactamente lo de siempre (test de caracterización): solo el que
// apaga algo cambia.
export const TENANT_MODULE_KEYS = [
    'admissions',
    'recruitment',
    'finance',
    'classroom',
    'surveys',
    'assessment',
    'catalog',
    'spiritualLife',
    'mentoring',
    'zoom',
    'accreditation',
];
export function isTenantModuleKey(value) {
    return typeof value === 'string' && TENANT_MODULE_KEYS.includes(value);
}
/** Encendido salvo que el seminario lo haya apagado explícitamente. */
export function isModuleEnabled(modules, key) {
    return modules?.[key] !== false;
}
export const TENANT_MODULE_TEMPLATES = ['full', 'sis'];
/** Las plantillas que aplica la plataforma. Después se ajusta módulo por módulo.
 *  - `full`: todo encendido (lo de siempre).
 *  - `sis`: solo lo académico (personas, programas, períodos, secciones,
 *    inscripción, expediente) y el portal básico del alumno. */
export function modulesForTemplate(template) {
    const on = template === 'full';
    return Object.fromEntries(TENANT_MODULE_KEYS.map((k) => [k, on]));
}
// ─── Qué rutas esconde cada módulo del seminario ───────────────────────────
// UNA sola fuente para el menú del personal, el menú del portal, la puerta de
// las rutas y el asistente (que no puede mandar a la página de un módulo
// apagado, ver assistant-chat.adapter): si un módulo está apagado, su entrada no aparece y su página
// devuelve al inicio. Las rutas son prefijos, con límite de segmento
// (`/curso` no es `/cursos`).
//
// Lo que no está acá no se esconde nunca: personas, alumnos, programas,
// períodos, secciones, expediente, usuarios, configuración y, en el portal,
// inicio, inscripción, mis cursos, historial y calendario. El camino TMAI SÍ es
// un módulo (`accreditation`): un seminario que no se acredita no lo necesita.
export const MODULE_ROUTES = {
    admissions: ['/admissions', '/form-templates'],
    recruitment: ['/crm'],
    finance: [
        '/tuition',
        '/scholarships',
        '/settings/integrations/mercadopago',
        '/portal-v2/payments',
        '/portal-v2/scholarships',
    ],
    classroom: [
        '/curso',
        '/materiales',
        '/grades',
        '/assignments',
        '/academic/anuncios',
        '/portal-v2/announcements',
    ],
    surveys: ['/encuestas', '/portal-v2/surveys'],
    assessment: [
        '/estandares',
        '/dialogo-socratico',
        '/practica-progreso',
        '/socratic',
        '/portal-v2/practica-socratica',
    ],
    catalog: ['/plantillas-syllabus', '/plantillas-curso', '/catalogo-libros'],
    spiritualLife: ['/portal-v2/scripture', '/portal-v2/journal', '/portal-v2/prayer'],
    mentoring: ['/portal-v2/mentor'],
    zoom: ['/settings/integrations/zoom'],
    /** El camino de acreditación TMAI (CCD, resultados, matriz, propuesta). */
    accreditation: ['/cap'],
};
const matches = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`);
/** El módulo al que pertenece una ruta, o null si no pertenece a ninguno. */
export function moduleOfPath(path) {
    let best = null;
    for (const [key, prefixes] of Object.entries(MODULE_ROUTES)) {
        for (const p of prefixes) {
            if (matches(path, p) && (!best || p.length > best.length))
                best = { key, length: p.length };
        }
    }
    return best?.key ?? null;
}
/** ¿Se muestra esta ruta en este seminario? Sin `modules` configurados, siempre. */
export function isPathEnabled(modules, path) {
    const key = moduleOfPath(path);
    return key === null || isModuleEnabled(modules, key);
}
//# sourceMappingURL=tenant-modules.js.map